import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import { createNotification } from '../../../Config/NotificationToast';
import Divider from '@mui/material/Divider';
import styled from '@emotion/styled';
import Select from "react-select";
import { FormGroup, } from "reactstrap";
import * as routes from "../../../Router/RoutesURL";
import { updateIsActiveStatus } from '../../../redux/actions/MasterDataAction/ProgramAction/programActions';
import { deleteMasterDataModule, getRecipeCollectionList } from '../../../redux/actions/MasterDataAction/RecipeCollection/RecipeCollectionAction';
import Delete from "../../../assets/images/CommonComponent/trash.svg";
import Modal from 'react-bootstrap/Modal';
import {
    stableSort,
    getComparator,
    rowOptions,
    options,
    getPermissionByAppName,
} from '../../../utils/Helper'
import './RecipeCollection.scss';
import { CircularProgress } from '@mui/material';
import { tabKeys } from '../../../Config/Constant';

const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))


const headCells = [
    {
        id: 'collection_name',
        disablePadding: true,
        label: 'COLLECTION',
    },
    {
        id: 'recipe_count',
        disablePadding: false,
        label: 'RECIPE COUNT',
    },
    {
        id: 'creation_datetime',
        disablePadding: false,
        label: 'CREATED ON',
    },
    {
        id: 'is_active',
        disablePadding: false,
        label: 'STATUS',
        width: '140px'
    },
    {
        id: 'action',
        disablePadding: false,
        label: 'ACTION',
        disableSorting: true
    },
];

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) =>
                (<TableCell
                    key={headCell.id}
                    align='left'
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                    {... headCell.width && {width: headCell.width}}
                >
                    <TableSortLabel
                        active={orderBy === headCell.id && !headCell.disableSorting}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        hideSortIcon={headCell.disableSorting}
                        disabled={headCell.disableSorting}
                    >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>)
                )}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { activeTab } = props;
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchText, setSearchText] = useState(searchParams.get('filter_text') || '');
    
    useEffect(() => {
        if (activeTab == tabKeys.masterData.RECIPE_COLLECTION) {
            setSearchText(searchParams.get('filter_text') || '');
        }
    }, [activeTab, searchParams]);

    const handleSearchRecipeCollection = (event) => {
        const newSearchText = event.target.value;
        setSearchText(newSearchText);

        const newParams = new URLSearchParams(searchParams);
        if (newSearchText) {
            newParams.set('filter_text', newSearchText);
        } else {
            newParams.delete('filter_text');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    };

    return (

        <div>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 },
            }}
            >
                <div className='col-xl-6 col-xxl-3'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Recipe Collection List
                    </MainHeading>
                </div>
                <div className='col-xl-6 col-xxl-9 RecipeSearchDiv'>
                    <div className="separator"></div>

                    <div className="mr-sm-2 searchDiv class-search ">
                        <input
                        value={searchText}
                            className="form-control mr-sm-2 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            onChange={handleSearchRecipeCollection}
                        ></input>
                    </div>
                </div>
            </Toolbar>
            <Divider />
        </div>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const RecipeTable = (props) => {
    const { activeTab, permission } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const [selected, setSelected] = useState([]);
    const [order, setOrder] = useState(searchParams.get('order_by_type') || '');
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') || '');
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('limit')) || 10);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [id, setId] = useState();
    const [recipeCollectionMainData, setRecipeCollectionMainData] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const navigate = useNavigate()
    const recipeCollectionData = useSelector(state => state?.getRecipeCollectionList);
    const getRecipeCollectionListData = useSelector(state => state?.getRecipeCollectionList?.getRecipeCollectionList);
    const updateStatusProDataRes = useSelector(state => state);
    const dispatch = useDispatch();

    useEffect(() => {
        if (activeTab == tabKeys.masterData.RECIPE_COLLECTION) {
            const sendRequest = {
                "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('limit') || 10,
                "filter_text":  searchParams.get('filter_text') || '',
                "order_by": searchParams.get('order_by') || '',
                "order_by_type": searchParams.get('order_by_type') || ''
            };
            dispatch(getRecipeCollectionList(sendRequest));
        }else{
            setOrder('');
            setOrderBy('');
            setRowsPerPage(10)
        }
    }, [activeTab, searchParams]);

    useEffect(()=>{
        if(!recipeCollectionData.loading)
            setShowLoader(false)
        if(!recipeCollectionData.loading && !getRecipeCollectionListData?.data?.recipe_collection_data && !recipeCollectionData.error){
            setShowLoader(true)
        }
    }, [recipeCollectionData.loading])

    useEffect(() => {
        if (recipeCollectionData.error !== "No data found") {
            setRecipeCollectionMainData(getRecipeCollectionListData && getRecipeCollectionListData?.data?.recipe_collection_data);
        }
        else {
            setRecipeCollectionMainData('');
        }

    }, [getRecipeCollectionListData, recipeCollectionData, updateStatusProDataRes])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('order_by_type', newOrder);
        newParams.set('order_by', property);
        setSearchParams(newParams, { replace: true });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = getRecipeCollectionListData && recipeCollectionMainData.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleChangePageNext = (newPage) => {
        setShowLoader(true)
        const nextPage = getRecipeCollectionListData?.data?.current_page_no + 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', nextPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangePagePrev = (newPage) => {
        setShowLoader(true)
        const prevPage = getRecipeCollectionListData?.data?.current_page_no - 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', prevPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeRowsPerPage = (event) => {
        setShowLoader(true)
        const newRowsPerPage = parseInt(event.value, 10);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('limit', newRowsPerPage.toString());
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
        setRowsPerPage(newRowsPerPage);
    };

    const handleChangeOption = (e, id) => {
        if (permission === "write") {
            if (e.value === "Active") {
                recipeCollectionMainData.find(v => v.id === id).is_active = 1;
            } else {
                recipeCollectionMainData.find(v => v.id === id).is_active = 0;
            }
            setRecipeCollectionMainData(recipeCollectionMainData)
            const sendRequest = {
                "feature_type": "recipe_collection",
                "id": id,
                "status": e.value === "Active" ? 1 : 0
            };
            dispatch(updateIsActiveStatus(sendRequest));
            setTimeout(() => {
                const sendValue = { "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('limit') || 10,
                "filter_text": searchParams.get('filter_text') || '',
                "order_by": searchParams.get('order_by') || '',
                "order_by_type": searchParams.get('order_by_type') || '' };
                dispatch(getRecipeCollectionList(sendValue));
            }, 100);
        } else {
            createNotification('warning', "Access Restricted");
        }
    }

    const handleNavigateRecipeCollection = (recipeCollectionId, collectionName, status) => {
        navigate(routes.RECIPE_LIST, {state: { recipeCollectionId, collectionName, status, permission } })

    };

    const handleNavigate = (collectionID,) => {
        if (permission === "write") {
            localStorage.setItem('add', false)
            navigate(routes.ADD_RECIPE_COLLECTION, { state: { collectionID, selection: "edit" } })
        } else {
            createNotification('warning', "Access Restricted");
        }
    };

    const handleDelete = (id) => {

        if (permission === "write") {
            setId(id)
            setShowDeleteModal(true);
        } else {
            createNotification('warning', "Access Restricted");
        }
    };


    const closeDeleteModal = () => {
            const sendRequestDelete = {
                "feature_type": "recipe_collection",
                "ids": id,
                onSuccessCallback: ()=>{
                    if(getRecipeCollectionListData?.data?.start === getRecipeCollectionListData?.data?.end){
                        const newParams = new URLSearchParams(searchParams);
                        newParams.set("page", (getRecipeCollectionListData?.data?.current_page_no - 1 || 1));
                        setSearchParams(newParams, { replace: true});
                    }else{
                        
                        const sendRequest = {
                            "pageNo": getRecipeCollectionListData?.data?.current_page_no || 1,
                            "pageSize": searchParams.get('limit') || 10,
                            "filter_text": searchParams.get('filter_text') || '',
                            "order_by": searchParams.get('order_by') || '',
                            "order_by_type": searchParams.get('order_by_type') || '' ,
                        };
                        dispatch(getRecipeCollectionList(sendRequest));
                    }
                    setShowDeleteModal(false);
                }
            };
            dispatch(deleteMasterDataModule(sendRequestDelete));
        }

    const cancelWarnModal = () => {
        setShowDeleteModal(false);
    }


    return (
        <>
            <Box sx={{ width: '100%' }} className="RecipeBox h-100">
            <Paper className='d-flex flex-column' sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
                      <EnhancedTableToolbar numSelected={selected.length} activeTab={activeTab} />
                            {
                                showLoader ?
                                <div className='w-100 text-center py-5'>
                                    <CircularProgress sx={{'color': '#74613C'}}/>
                                </div>
                                :
                                recipeCollectionMainData ?
                                <TableContainer sx={{ pt: 0, pr: 3, pb: 1, pl: 3, height: '100%' }}>
                                    <Table
                                        sx={{ minWidth: 750 }}
                                        aria-labelledby="tableTitle"
                                        size='small'
                                        stickyHeader
                                    >
                                        <EnhancedTableHead
                                            numSelected={selected.length}
                                            order={order}
                                            orderBy={orderBy}
                                            onSelectAllClick={handleSelectAllClick}
                                            onRequestSort={handleRequestSort}
                                            rowCount={getRecipeCollectionListData && recipeCollectionMainData?.length}
                                        />
                                        <TableBody>
                                            {
                                            
                                            recipeCollectionData && stableSort(recipeCollectionMainData, getComparator(order, orderBy))
                                                    .map((row, index) => {

                                                        const labelId = `enhanced-table-checkbox-${index}`;
                                                        return (
                                                            <TableRow hover onClick={(event) => handleClick(event, row.title)} role="checkbox"

                                                                tabIndex={-1}
                                                                key={row.id}

                                                            >
                                                                <TableCell component="th" id={labelId} scope="row" padding="none"
                                                                    sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{row.collection_name}</TableCell>
                                                                <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{row.recipe_count} <span
                                                                    className="RecipeText">Recipe</span> </TableCell>
                                                                <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{row.creation_datetime}</TableCell>
                                                                <TableCell align="left"
                                                                    className='ActiveInactiveCell'
                                                                    sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>
                                                                    <Select
                                                                        className="react-select status-select"
                                                                        classNamePrefix="react-select"
                                                                        onChange={(e) => { handleChangeOption(e, row.id, row.is_active) }}
                                                                        value={row.is_active === 1 ? { label: "Active", value: "Active" } : { label: "Inactive", value: "Inactive" }}
                                                                        options={options}
                                                                        isSearchable={false}
                                                                        menuPlacement="auto"
                                                                        menuPosition="absolute"   
                                                                        menuPortalTarget={null}
                                                                        theme={(theme) => ({
                                                                            ...theme,
                                                                            isFocused: "#74613C",
                                                                            colors: {
                                                                                ...theme.colors,
                                                                                primary25: '#F5F5F5',
                                                                                primary: '#f6f4f0',

                                                                            },
                                                                        })}
                                                                        getOptionLabel={(row) => (
                                                                            <><span className={row.label === "Active" ? "ActiveClass" : "InactiveClass"} >
                                                                                {row.label}
                                                                            </span>
                                                                                {row.is_active === 1 && (
                                                                                    <div

                                                                                    ></div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    />
                                                                </TableCell>
                                                                <TableCell align="left" className='View' >
                                                                    <ul className="list-group d-flex flex-row ">
                                                                        <li
                                                                            className={row.is_active == 1 ? 'list-group-item ViewEditClick p-0 ' : "list-group-item ViewEditNotClick p-0"}
                                                                            onClick={row.is_active == 1 ? () => { handleNavigateRecipeCollection(row.id, row.collection_name, row.is_active) } : undefined}><i className="fas fa-eye mr-1"></i> View</li>
                                                                        {
                                                                            getPermissionByAppName("Recipe Master") === "write" &&
                                                                            <>
                                                                                <li
                                                                                    className={row.is_active == 1 ? 'list-group-item ViewEditClick p-0 ' : "list-group-item ViewEditNotClick p-0"}
                                                                                    onClick={row.is_active == 1 ? () => { handleNavigate(row.id) } : undefined}><i className="fa fa-pen mr-1"></i> Edit</li>
                                                                                <li className="list-group-item Delete p-0" onClick={() => { handleDelete(row.id) }}><img src={Delete} className="mr-1 mb-1" alt="Avatar" width="14px" height="16px" /> Delete</li>
                                                                            </>
                                                                        }
                                                                    </ul>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                : <div className='text-center w-100 text-muted mt-3'>No Records </div>
                        }
                    </Paper>
                    {
                        recipeCollectionMainData
                        &&
                        <div className='paginationBlock'>
                            <div className='textData'><p>Items per page: </p></div>
                            <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                                <Select
                                    placeholder={rowsPerPage}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    value={rowsPerPage}
                                    options={rowOptions}
                                    menuPlacement="top"
                                    menuPosition="fixed"
                                    isSearchable={false}
                                    onChange={handleChangeRowsPerPage}
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: '#F5F5F5',
                                            primary: '#74613C',
                                        },
                                    })}
                                />
                            </FormGroup>
                            {getRecipeCollectionListData?.data && <p className='endText'>   {getRecipeCollectionListData?.data?.start} - {getRecipeCollectionListData?.data?.end} of {getRecipeCollectionListData?.data?.total}</p>}
                            <p>
                            
                                <button className={`btnPrev ${getRecipeCollectionListData?.data?.current_page_no === 1 ? "opacityBtns" : ''}`} disabled={getRecipeCollectionListData?.data?.current_page_no === 1} onClick={() => { handleChangePagePrev() }}>
                                    <ArrowBackIosNewSharpIcon className='iconBtn' />
                                </button> 
                                <button className={`btnPrev ${getRecipeCollectionListData?.data?.current_page_no === getRecipeCollectionListData?.data?.total_pages ? "opacityBtns" : ''}`} disabled={getRecipeCollectionListData?.data?.current_page_no === getRecipeCollectionListData?.data?.total_pages} onClick={() => { handleChangePageNext() }}>
                                    <ArrowForwardIosSharpIcon className='iconBtn' />
                                </button></p>
                        </div>
                    }
                </Box>
            <Modal centered className="TeamMember-modal-warning br-8" show={showDeleteModal} onHide={() => { setShowDeleteModal(false) }}>
                <Modal.Header>
                    <div className="modalText pb-4">Are you sure?</div>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <label htmlFor="exampleFormControlInput1" className="form-label DeleteDesc">You want to delete this record?</label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-success greenButton mr-3" onClick={cancelWarnModal}>
                        Cancel</button>
                    <button type="button" className="btn btn-danger redButton " onClick={closeDeleteModal}>
                        Delete</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default RecipeTable;